import { Directive, OnInit, Optional, Renderer2, OnDestroy, ElementRef } from '@angular/core';
import { AbstractControl, UntypedFormControl, FormControlDirective, FormControlName } from '@angular/forms';

/**
 * This directive is used to automatically validate the form fields that has a Validators.required validation.
 * Won't need to change all Validators.required instances as this will work out of the box to all of the form controls.
 *
 */
@Directive({
  // TODO: check if its deprecated
  selector: '[formControl], [formControlName]',
})
export class WhitespaceOnRequiredDirective implements OnInit, OnDestroy {
  // So we can remove this listener when the component is destroyed.
  controlListener: () => void;

  // Handles the current field / form control to be manipulated.
  control: UntypedFormControl;

  constructor(
    @Optional() private formControlDir: FormControlDirective,
    @Optional() private formControlName: FormControlName,
    public elementRef: ElementRef,
    public renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    // Ensures that the input is a Form control
    this.control = this.formControlDir?.control || this.formControlName?.control;

    // Listens to the input value being entered.
    // The purpose of this is to check if the input is required.
    // When the input is required, include the check for whitespaces.
    this.controlListener = this.renderer.listen(this.elementRef.nativeElement, 'keydown', () => {
      // First ensures that the input is a Form Control and has a 'required' validator before doing anything else.
      if (this.control?.validator) {
        const validator = this.control.validator({} as AbstractControl);
        if (validator?.required) {
          // Set a delay because the Validators.required always overrides the whitespace check result if no delay is set.
          setTimeout(() => {
            this.checkWhitespaceValidator();
          }, 10);
        }
      }
    });
  }

  /**
   * Checks for whitespace and invalidates fields with whitespace-only value.
   */
  checkWhitespaceValidator() {
    if ((this.control?.value?.toString() || '').trim().length === 0) {
      this.control?.setErrors({ required: true });
    }
  }

  ngOnDestroy(): void {
    // Removes the listener
    if (this.controlListener) {
      this.controlListener();
    }
  }
}
